import { render, staticRenderFns } from "./NewTeam.vue?vue&type=template&id=bb1d6b96&scoped=true&"
import script from "./NewTeam.vue?vue&type=script&lang=js&"
export * from "./NewTeam.vue?vue&type=script&lang=js&"
import style0 from "./NewTeam.vue?vue&type=style&index=0&id=bb1d6b96&prod&lang=scss&scoped=true&"
import style1 from "./NewTeam.vue?vue&type=style&index=1&id=bb1d6b96&prod&lang=scss&"
import style2 from "./NewTeam.vue?vue&type=style&index=2&id=bb1d6b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1d6b96",
  null
  
)

export default component.exports